import React, { Component } from 'react';
import { Typography } from '@material-ui/core'
import { muiWithStyles, MuiGrid, MuiButton, MuiTypography, MuiFab, MuiTextField, MuiInfoIcon } from '../../../ui/MaterialUIComponents';
import { withStyles } from '@material-ui/core/styles';
import theme from '../../../../assests/theme'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import '../../../../App.css';
import * as Constants from '../../../../constants';
const styles = (theme) => ({

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 240,

  },
  textFieldStyle: {
    width: '100%',


  }

})


export class SchoolInformation extends Component {

  render() {
    const { classes, i18n } = this.props

    return (
      <MuiGrid container xs={12} >

        <MuiGrid container xs={12} >
          <MuiGrid item xs={6} style={{ width: '100%', paddingRight: 10 }} align='left'>
            <MuiGrid container item justify="flex-start" >
              <MuiTypography variant={theme.typographyStyles.H6} style={theme.gridHeaderTextStyle}  >
                {i18n.schoolInformationTab.schoolAddress}
              </MuiTypography>
              <MuiInfoIcon color="primary" size="small" onClick={(event) => this.props.showContextualHelp(this.props, event)} />
            </MuiGrid>
          </MuiGrid>
          <MuiGrid item xs={6} style={{ width: '100%' }} align='left'>
            <MuiTypography variant={theme.typographyStyles.H6} style={theme.gridHeaderTextStyle} >
              {i18n.schoolInformationTab.schoolContactInfo}
            </MuiTypography>
          </MuiGrid>

        </MuiGrid>

        <MuiGrid container xs={12} justify='space-between'>
          <MuiGrid container xs={6} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              <MuiTextField
                id="name"
                className={classes.textFieldStyle}
                label={i18n.schoolInformationTab.schoolName}
                onChange={(event) => this.props.handleChange('name', event)}
                margin="normal"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                required
                value={this.props.activeSchool.name}
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid item xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.error.name !== undefined ? this.props.error.name : this.props.errors.name}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>

          <MuiGrid container item xs={6} justify='space-between' style={{ paddingTop: 15 }}>
            <MuiGrid container xs={6} style={{ paddingRight: 10 }}>
              <MuiGrid item xs={12} >
                <PhoneInput
                  id="phone"
                  onChange={(event,data) => this.props.handleChangeOfPhone(event, data,'primaryPhoneNumber')}
                  value={this.props.activeSchool.primaryPhoneNumber}
                  inputClass='phone-input-primary'
                  style={theme.muiTextFieldStyleForMainScreen}
                  disabled={this.props.isEditNotAllowed}
                  disableDropdown={this.props.isEditNotAllowed}
                  label={i18n.schoolInformationTab.phoneNumber}
                  country={Constants.PHONE_DEFAULT_COUNTRY_CODE}
                  placeholder={i18n.schoolInformationTab.phoneNumber}
                  inputProps={{
                    required: true,
                  }}
                />
              </MuiGrid>
              <MuiGrid xs={12} align='left'>
                <MuiTypography color="error" variant="caption">
                  {this.props.primaryPhoneNumberError}
                </MuiTypography>
              </MuiGrid>

            </MuiGrid>
            <MuiGrid container xs={6} style={{ paddingRight: 10 }}>
              <MuiGrid item xs={12} >
                <PhoneInput
                  id="phone"
                  onChange={(event,data) => this.props.handleChangeOfPhone(event,data, 'secondaryPhoneNumber')}
                  value={this.props.activeSchool.secondaryPhoneNumber}
                  disabled={this.props.isEditNotAllowed}
                  country={Constants.PHONE_DEFAULT_COUNTRY_CODE}
                  inputClass='phone-input-sec'
                  disableDropdown={this.props.isEditNotAllowed}
                  style={theme.muiTextFieldStyleForMainScreen}
                  label={i18n.schoolInformationTab.phoneNumber}
                  placeholder={i18n.schoolInformationTab.alternatePhonenUmber}

                />
              </MuiGrid>
              <MuiGrid xs={12} align='left'>
                <MuiTypography color="error" variant="caption">
                  {this.props.secondaryPhoneNumberError}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>

          </MuiGrid>
        </MuiGrid>

        <MuiGrid container xs={12} justify='space-between' >
          <MuiGrid container xs={6} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              < MuiTextField
                id="line1"
                fullWidth
                onChange={(event) => this.props.handleChangeOfAddress('line1', event)}
                required
                label={i18n.schoolInformationTab.address}
                margin="normal"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                className={classes.textFieldStyle}
                value={this.props.activeSchool.address.line1}
                disabled={this.props.isEditNotAllowed}
              />
            </MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.address}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={6} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              < MuiTextField
                id="email"
                onChange={(event) => this.props.handleChange('email', event)}
                className={classes.textFieldStyle}
                label={i18n.schoolInformationTab.email}
                placeholder="example@gmail.com"
                margin="normal"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                required
                value={this.props.activeSchool.email
                }
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.email}
              </MuiTypography>
            </MuiGrid>

          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12} justify='space-between' >
          <MuiGrid container xs={3} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              < MuiTextField
                className={classes.textFieldStyle}
                id="city"
                required
                onChange={(event) => this.props.handleChangeOfAddress('city', event)}
                label={i18n.schoolInformationTab.city}
                margin="normal"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                value={this.props.activeSchool.address.city}
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.city}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>


          <MuiGrid container xs={3} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12}  >
              < MuiTextField
                className={classes.textFieldStyle}
                id="pincode"
                required
                onChange={(event) => this.props.handleChangeOfAddress('pincode', event)}
                label={i18n.schoolInformationTab.pincode}
                margin="normal"
                marginLeft="spacing ()"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                value={this.props.activeSchool.address.pincode}
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.pincode}
              </MuiTypography>
            </MuiGrid>

          </MuiGrid>

          <MuiGrid container xs={6} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              < MuiTextField
                id="website"
                onChange={(event) => this.props.handleChange('website', event)}
                className={classes.textFieldStyle}
                label={i18n.schoolInformationTab.website}
                placeholder={i18n.schoolInformationTab.websitePlaceholder}
                margin="normal"
                variant="outlined" InputLabelProps={{ shrink: true, }}
                value={this.props.activeSchool.website}
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid item xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.website}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>

        </MuiGrid>
        <MuiGrid container xs={12} justify='space-between' >
          <MuiGrid container xs={6} style={{ paddingRight: 10 }}>
            <MuiGrid item xs={12} >
              < MuiTextField
                className={classes.textFieldStyle}
                id="country"
                fullWidth
                onChange={(event) => this.props.handleChangeOfAddress('country', event)}
                label="Country"
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true, }}
                required
                value={this.props.activeSchool.address.country}
                disabled={this.props.isEditNotAllowed}
              /></MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.props.errors.country}
              </MuiTypography>

            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={6} style={{ paddingRight: 10 }} justify='flex-end' alignItems='flex-end'>

            <MuiGrid xs align='right'>

              <MuiButton
                style={!this.props.showDialog ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
                disabled={!this.props.showDialog} id="saveButton" onClick={() => { this.props.onClickOfSave(false) }}>
                save
              </MuiButton>
            </MuiGrid>
          </MuiGrid>

        </MuiGrid>
      </MuiGrid>
    )
  }
}
export default withStyles(styles)(SchoolInformation)